module.exports = __webpack_public_path__ + "img/space_laser_attack.3469fc73.png";